import { render, staticRenderFns } from "./AdminSupport.vue?vue&type=template&id=41d63b66&"
import script from "./AdminSupport.vue?vue&type=script&lang=js&"
export * from "./AdminSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports